import type { ReactElement } from 'react';
import Edit from '@mui/icons-material/Edit';
import { IconButton } from 'components/ui';
import { SUMMARY_DASHBOARD_TEST_IDS } from '../../SummaryDashboard.constants';

interface DashboardComponentEditButtonProps {
  onClick: () => void;
  // The tile's own title, so the accessible name distinguishes one tile's button from the next.
  // Falls back to the type label, because a tile is not required to carry a title.
  label: string;
}

const TOOLTIP_LABEL = 'Edit component';

// The per-tile entry point into the Edit Summary dialog. Rendered by each card rather than laid
// over the tile from DashboardGrid: the generic card already owns its top-right corner with the
// type chip and wants the button beside it in flow, while a totals card has no header row and
// places it absolutely. Positioning is therefore the caller's business; this owns only the control.
const DashboardComponentEditButton = ({ label, onClick }: DashboardComponentEditButtonProps): ReactElement => (
  <IconButton
    aria-label={`Edit ${label}`}
    data-testid={SUMMARY_DASHBOARD_TEST_IDS.componentEditButton}
    onClick={onClick}
    tooltipLabel={TOOLTIP_LABEL}
    variant="ghost"
    visualSize="compact">
    <Edit fontSize="inherit" />
  </IconButton>
);

export default DashboardComponentEditButton;
